import { render } from "./openPacklist.vue?vue&type=template&id=268e3db7&scoped=true"
import script from "./openPacklist.vue?vue&type=script&lang=js"
export * from "./openPacklist.vue?vue&type=script&lang=js"

import "./openPacklist.vue?vue&type=style&index=0&id=268e3db7&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268e3db7"]])

export default __exports__